// sessionStorage is per tab: a new tab knows nobody until the API answers.
export function createSessionGate() {
  let open!: () => void;
  const opened = new Promise<void>((resolve) => (open = resolve));

  return {
    open,
    ready: (hasSession: boolean) => (hasSession ? Promise.resolve() : opened),
  };
}
